import React, { useState } from 'react';
import i1 from '../assets/images/i1.png';
import i2 from '../assets/images/i2.png';
import i3 from '../assets/images/i3.png';
import i4 from '../assets/images/i4.png';
import i5 from '../assets/images/i5.png';

const images = [i1, i2, i3, i4, i5];

const FlowerGift: React.FC = () => {
    const [howtoOpen, setHowtoOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    function toggleHowTo() {
        setHowtoOpen(!howtoOpen);
    }

    return (
        <section className="bg-gradient-warm py-24 md:py-32 px-4">
            <div className="max-w-2xl mx-auto">
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-dry_sage mb-4">
                    приятный подарок 
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-6">
                    Букет&nbsp;цветов 
                </h2>
                <div className="flex items-center justify-center gap-3 mb-12 divider-ornament-green max-w-xs mx-auto">
                    <span className="text-dry_sage text-xl animate-heart">♥</span>
                </div>
                <div className="golden-border bg-white/60 backdrop-blur-sm rounded-2xl shadow-card p-8 md:p-12">
                    <span className="block text-5xl mb-6">💐</span>
                    <p className="font-sans text-base md:text-lg text-prussian_blue/70 leading-relaxed">
                        Мы очень ценим ваше желание порадовать нас цветами!
                        Однако, вместо букета, который вы хотели бы подарить нам в день торжества, 
                        мы будем благодарны, если вы положите эту сумму, которую хотели бы потратить на букет, на наш
                        <span className="font-semibold text-prussian_blue"> депозит в цветочном магазине </span>
                        по этой ссылке: <a href="https://fridaflowers.by/cvetochnaya_kopilka/anastasiya-stanislav"> 
                            <span 
                                className="font-semibold text-prussian_blue underline">
                                https://fridaflowers.by
                            </span>
                        </a>
                    </p>
                    <button onClick={toggleHowTo} className=" border border-5px py-2 px-4 rounded-lg bg-alice_blue border-color: #B3C295 font-semibold text-base md:text-lg text-prussian_blue/100 leading-relaxed my-3">
                        Нажмите сюда чтобы открыть инструкцию по оплате.
                    </button>
                    {
                        !howtoOpen ? <p></p> : 
                    <div className="text-center p-8 text-lg">
                    <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(images[0])}>
                            <p> <span className="font-semibold text-prussian_blue text-2xl"> Инструкция по оплате </span> <div className="p-2"></div>
                                <span className="font-semibold text-prussian_blue"> Шаг 1. </span> Перейти по ссылке, которая указана выше. <div className="p-2" ></div>
                                <span className="font-semibold text-prussian_blue"> Шаг 2. </span> Укажите в окошке любую сумму, которую вы готовы внести в копилку. <div className="p-2"></div>
                                <span className="font-semibold text-prussian_blue"> Шаг 3. </span> Нажмите "в копилку". <div className="p-2"></div>
                            </p>
                            <img src={images[0]} alt="" className="w-xs h-xs mx-auto object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                        </div>
                    <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(images[1])}>
                            <p className="py-5">
                                <span className="font-semibold text-prussian_blue"> Шаг 4. </span> Нажмите "Оформить заказ".
                            </p>
                            <img src={images[1]} alt="" className="w-xs h-xs mx-auto object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                        </div>
                     <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(images[2])}>
                            <p className="py-5"> 
                                <span className="font-semibold text-prussian_blue "> Шаг 5. </span> Заполните поля и нажмите "Оформить заказ".
                            </p>
                            <img src={images[2]} alt="" className="w-xs h-xs mx-auto object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                        </div>
                        <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(images[3])}>
                            <p className="py-5"> 
                                <span className="font-semibold text-prussian_blue"> Шаг 6. </span> Введите данные карты. Обязательно перепроверьте данные, которые вы внесли.
                            </p>
                            <img src={images[3]} alt="" className="w-xs h-xs mx-auto object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                        </div>
                        <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(images[4])}>
                            <p className="py-5"> 
                                <span className="font-semibold text-prussian_blue mb-8"> Шаг 7. </span> Нажмите "Оплатить". Готово!
                            </p>
                            <img src={images[4]} alt="" className="w-xs h-xs mx-auto object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                        </div>
                        </div>
                    }
                    <p className="font-sans text-base md:text-lg text-prussian_blue/70 leading-relaxed mb-8">
                        Таким образом нам один раз в две недели будут доставлять новый букет! Настя будет очень счастлива!
                        И мы сможем на&nbsp;протяжении длительного времени&nbsp;радоваться цветами от вас.🌸
                    </p>
                    <div className="w-12 h-px bg-dry_sage/30 mx-auto mb-8" />
                    <p className="font-serif text-base md:text-lg text-prussian_blue/70 italic">
                        Спасибо за&nbsp;понимание и&nbsp;за&nbsp;то, что делаете наш день особенным!
                    </p>
                </div>
            </div>

            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/55 backdrop-blur-md cursor-pointer animate-fadeIn"
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt=""
                        className="max-h-[90vh] max-w-[90vw] object-contain rounded-xl shadow-2xl animate-scaleIn inset-0 m-auto"
                        onClick={() => setSelectedImage(null)}
                    />
                </div>
            )}
        </section>
    );
};


export default FlowerGift;

